import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import { deleteAdminRally, getAdminRallies } from '../../../api/admin/rallies';
import { setAdminRallies } from '../../../store/adminSlices/rallies';
const ConfirmDeleteRally = ({ rallyId }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [deleteRallyStatus, setDeleteRallyStatus] = useState(null);
    const deleteRally = async () => {
        try {
            setDeleteRallyStatus('pending');
            await deleteAdminRally(rallyId);
            const rallies = await getAdminRallies();
            dispatch(setAdminRallies(rallies));
            setDeleteRallyStatus('success');
            dispatch(setIsModalOpen(false));
            dispatch(setModalContent(null));
        }
        catch (error) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    return (_jsxs("div", { className: 'modal-content confirm-action', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('admin.confirm_delete_rally'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsxs(ButtonsGroup, { justify: 'center', children: [_jsx(Button, { label: t('button.cancel'), onClick: () => {
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                            }, disabled: deleteRallyStatus === 'pending' || deleteRallyStatus === 'success' }), _jsx(Button, { variant: 'outlined', label: t('button.delete_rally'), onClick: deleteRally, disabled: deleteRallyStatus === 'pending' || deleteRallyStatus === 'success' })] }) })] }));
};
export default ConfirmDeleteRally;
